import axios from '../api-axios'
import encode from 'strict-uri-encode'

export default {
  fetchMenu(id) {
    return axios.get(`/menu/${encode(id)}`)
  }
}
